var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-table', {
    ref: "table",
    staticClass: "corrective-actions-results",
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "id": "corrective-actions-results",
      "fields": _vm.fields,
      "items": _vm.entities
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "chemtracker-empty-text"
        }, [_vm._v("\n        No corrective actions have been defined yet.\n      ")])];
      }
    }, {
      key: "cell(field_inc_invest_action_complete)",
      fn: function (row) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.selectedActionItem,
            expression: "selectedActionItem"
          }],
          attrs: {
            "type": "checkbox",
            "name": 'action-name-' + row.index,
            "id": 'action-name-' + row.index,
            "data-entity-uuid": row.item.id,
            "disabled": _vm.disabled
          },
          domProps: {
            "value": row.item.id,
            "checked": Array.isArray(_vm.selectedActionItem) ? _vm._i(_vm.selectedActionItem, row.item.id) > -1 : _vm.selectedActionItem
          },
          on: {
            "change": [function ($event) {
              var $$a = _vm.selectedActionItem,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = row.item.id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.selectedActionItem = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.selectedActionItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.selectedActionItem = $$c;
              }
            }, function ($event) {
              return _vm.updateCompletedStatus($event);
            }]
          }
        })];
      }
    }])
  }), _vm._v(" "), !_vm.disabled ? _c('b-button', {
    on: {
      "click": _vm.showDialog
    }
  }, [_vm._v("\n    Add Corrective/Preventative Action\n  ")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "add-corrective-action",
      "centered": "",
      "scrollable": "",
      "title": "Add Corrective/Preventative Actions",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "lg-modal-body-padded"
  }, [_c('add-metadata-entity', {
    attrs: {
      "add-class": _vm.addClass,
      "association-bundle": "incident_investigation",
      "association-uuid": _vm.investigationUuid,
      "metadata-type": "incident_correct_prevent_action"
    },
    on: {
      "submit-form-data": function ($event) {
        return _vm.handleAddAction($event);
      }
    }
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }